export default __webpack_public_path__ + "static/media/section_intention_m.99627d63.svg";